import { Role } from "@rosette/ts/src/business/role/Role.js";
import { getRoleTagClasses } from "@/components/icon/getRoleIcon.js";
import React from "react";
import Link from "next/link";
import { Pill } from "@rosette/web_components/src/ui/Pill.js";


export interface TagProps {
    name: string;
    title: string;
    href?: string;
    /** Text and background colour classes, such as "bg-role-gold text-white". */
    colourClasses: string;
}


export function createTagProps(role: Role): TagProps {
    return {
        name: role.getName(),
        title: role.getDesc(),
        href: (role === Role.MEMBUR ? "/premium" : undefined),
        colourClasses: getRoleTagClasses(role),
    };
}


function Tag({ name, title, href, colourClasses }: TagProps) {
    const pill = (
        <Pill className={colourClasses} title={title}>
            {name}
        </Pill>
    );
    if (href) {
        return (
            <Link className="hover:no-underline" href={href}>
                {pill}
            </Link>
        );
    }
    return pill;
}


interface TagsProps {
    tags: TagProps[];
}


export function Tags({ tags }: TagsProps) {
    const tagElems = [];
    for (const tag of tags) {
        tagElems.push(<Tag key={tag.name} {...tag} />);
    }
    return (
        <>
            {tags.length > 0 && (
                <div className="flex flex-row flex-wrap gap-1 pt-3">
                    {tagElems}
                </div>
            )}
        </>
    );
}
